const DepositLinkReducers = (state = "", action) => {
  switch (action.type) {
    case "storeDepositLink":
      return action.payload;
    default:
      return state;
  }
};
export default DepositLinkReducers;
